
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.875 9.25a4.486 4.486 0 01-4.5-4.5c0-2.46 2.004-4.5 4.5-4.5 2.46 0 4.5 2.04 4.5 4.5 0 2.496-2.04 4.5-4.5 4.5zm3.129 1.125c2.601 0 4.746 2.145 4.746 4.746v1.441c0 .95-.773 1.688-1.688 1.688H1.688C.738 18.25 0 17.512 0 16.562v-1.44c0-2.602 2.11-4.747 4.71-4.747h.599c.773.387 1.652.563 2.566.563.914 0 1.758-.176 2.531-.563h.598z"}})])
          )
        }
      }
    